const PlatformFeatureEnum = Object.freeze({
    BASIC_VISIBILITY_GROUPS: 'BASIC_VISIBILITY_GROUPS',
    ADVANCED_VISIBILITY_GROUPS: 'ADVANCED_VISIBILITY_GROUPS',
    ADVANCED_RATE_PLANS: 'ADVANCED_RATE_PLANS'
});

export default PlatformFeatureEnum;
